import React from 'react';
import ProductImageCarousel from '../ui/ProductImageCarousel';

interface SpecificationsGalleryProps {
  images: string[];
  title: string;
}

const SpecificationsGallery: React.FC<SpecificationsGalleryProps> = ({
  images,
  title
}) => {
  return (
    <div className="specifications-gallery">
      <div className="specifications-carousel-container">
        <ProductImageCarousel
          images={images}
          alt={title}
          className="specifications-carousel"
        />
      </div>
    </div>
  );
};

export default SpecificationsGallery;
